module.exports = __webpack_public_path__ + "static/img/seckill-price-wrap-disable.e7cd3cc4.png";